<button mat-icon-button (click)="infoClick()" [id]="buttonName" aria-label="Get more info"
    matTooltip="Get more info" matTooltipPosition="right" [class]="class">
    <mat-icon>info_outline</mat-icon>
</button><span matTooltip="Info" #tooltip="matTooltip" matTooltipPosition="right"></span>